'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import NonIdealState from '@/components/ui/NonIdealState';
import { SearchResponse } from '@/apiTypes/types';
import SearchCompaniesContent from '@/components/search/scope/SearchCompaniesContent';
import { searchNoResultImage } from '@/lib/helpers/hardcodedImages';

interface IProps {
  results: SearchResponse['companies'];
  query?: string;
}

export const CompanySearch: React.FC<IProps> = ({ results, query }) => {
  const { t } = useTranslation();
  const searchTerm = query?.length ? ` “${query}”` : '';

  if (results.items.length === 0) {
    return (
      <NonIdealState
        layout="horizontal"
        title={t('components.search.noCompanyResults', { query: searchTerm })}
        imageUrl={searchNoResultImage()}
      />
    );
  }
  return (
    <SearchCompaniesContent
      items={results.items}
      pagination={results.pagination}
    />
  );
};
